"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var SiteReleaseTerminationConverter_1 = require("./conversions/price-termination/SiteReleaseTerminationConverter");

var SiteReleaseTerminationConverterImpl_1 = require("./conversions/price-termination/SiteReleaseTerminationConverterImpl");

var SiteReleaseTerminationItemConverter_1 = require("./conversions/price-termination/SiteReleaseTerminationItemConverter");

var SiteReleaseTerminationItemConverterImpl_1 = require("./conversions/price-termination/SiteReleaseTerminationItemConverterImpl");

var SiteReleaseTerminationUploadConverter_1 = require("./conversions/price-termination/SiteReleaseTerminationUploadConverter");

var SiteReleaseTerminationUploadConverterImpl_1 = require("./conversions/price-termination/SiteReleaseTerminationUploadConverterImpl");

var SiteReleaseTerminationUploadedItemConverter_1 = require("./conversions/price-termination/SiteReleaseTerminationUploadedItemConverter");

var SiteReleaseTerminationUploadedItemConverterImpl_1 = require("./conversions/price-termination/SiteReleaseTerminationUploadedItemConverterImpl");

var SiteReleaseConverter_1 = require("./conversions/SiteReleaseConverter");

var SiteReleaseConverterImpl_1 = require("./conversions/SiteReleaseConverterImpl");

var SiteReleaseItemConverter_1 = require("./conversions/SiteReleaseItemConverter");

var SiteReleaseItemConverterImpl_1 = require("./conversions/SiteReleaseItemConverterImpl");

var SiteReleaseUploadConverter_1 = require("./conversions/SiteReleaseUploadConverter");

var SiteReleaseUploadConverterImpl_1 = require("./conversions/SiteReleaseUploadConverterImpl");

var SiteReleaseUploadedItemConverter_1 = require("./conversions/SiteReleaseUploadedItemConverter");

var SiteReleaseUploadedItemConverterImpl_1 = require("./conversions/SiteReleaseUploadedItemConverterImpl");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(SiteReleaseAppModule, _AppModule_1$AppModul);

  function SiteReleaseAppModule() {
    var _this;

    _classCallCheck(this, SiteReleaseAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'releaseSiteAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(SiteReleaseConverter_1.SiteReleaseConverter).to(SiteReleaseConverterImpl_1.SiteReleaseConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteReleaseItemConverter_1.SiteReleaseItemConverter).to(SiteReleaseItemConverterImpl_1.SiteReleaseItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteReleaseUploadConverter_1.SiteReleaseUploadConverter).to(SiteReleaseUploadConverterImpl_1.SiteReleaseUploadConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteReleaseUploadedItemConverter_1.SiteReleaseUploadedItemConverter).to(SiteReleaseUploadedItemConverterImpl_1.SiteReleaseUploadedItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      this.configurePriceTerminationParts();
    }
  }, {
    key: "configurePriceTerminationParts",
    value: function configurePriceTerminationParts() {
      typescript_ioc_1.Container.bind(SiteReleaseTerminationConverter_1.SiteReleaseTerminationConverter).to(SiteReleaseTerminationConverterImpl_1.SiteReleaseTerminationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteReleaseTerminationItemConverter_1.SiteReleaseTerminationItemConverter).to(SiteReleaseTerminationItemConverterImpl_1.SiteReleaseTerminationItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteReleaseTerminationUploadConverter_1.SiteReleaseTerminationUploadConverter).to(SiteReleaseTerminationUploadConverterImpl_1.SiteReleaseTerminationUploadConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteReleaseTerminationUploadedItemConverter_1.SiteReleaseTerminationUploadedItemConverter).to(SiteReleaseTerminationUploadedItemConverterImpl_1.SiteReleaseTerminationUploadedItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return SiteReleaseAppModule;
}(AppModule_1.AppModule);

exports.SiteReleaseAppModule = SiteReleaseAppModule;